import { Slot } from '@radix-ui/react-slot';
import React from 'react';
import type { ExtendWithCommonProps } from '../../types';
import { IconButton, type IconButtonProps } from '../icon-button/icon-button';
import { TagButton } from './tag-button';
import { useTag } from './tag-context';

export type TagCloseProps = ExtendWithCommonProps<{
  children?: React.ReactNode;
  asChild?: boolean;
}, IconButtonProps
>;

export const TagClose = ({ children, asChild, ...props }: TagCloseProps) => {
  const context = useTag();

  const { controlled, disabled, onOpenChange, open, setControlledOpen } = {
    ...context,
    ...props,
  };
  const Tag = asChild ? Slot : TagButton;
  return (
    <Tag
      {...props}
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          if (controlled) {
            onOpenChange && onOpenChange(!open);
          } else if (setControlledOpen) {
            setControlledOpen(!open);
          }
        }
      }}
    >
      {!asChild && (
        <IconButton.Icon color="c-inverted" icon="close-without-circle" />
      )}
      {children}
    </Tag>
  );
};

TagClose.displayName = 'Tag.Close';
